import styled from 'styled-components';
import { white } from '@bufferapp/ui/style/colors';
import Masonry from 'react-masonry-css';
import { GRID_GAP, GRID_PADDING } from '../config';

export const ListStyled = styled.div`
  display: grid;
  grid-gap: ${GRID_GAP}px;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-auto-rows: 0;
  height: calc(100% - 64px);
  min-height: calc(100% - 64px);

  list-style: none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0 ${GRID_PADDING}px;
  margin-top: 8px;
`;

export const MasonryStyled = styled(Masonry)`
  display: flex;
  width: auto;
  padding: 20px 40px 8px ${GRID_PADDING - GRID_GAP}px;

  .ideas-masonry-column {
    padding-left: ${GRID_GAP}px;
    background-clip: padding-box;
  }

  .ideas-masonry-column > div {
    margin-bottom: ${GRID_GAP}px;
  }
`;

export const LoadingWrapper = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-auto-rows: 0px;
  height: calc(100% - 64px);
  min-height: calc(100% - 64px);
  overflow: hidden scroll;
  padding: 0px 40px;
  margin-top: 8px;
`;

export const EmptyCard = styled.div`
  background: ${white};
  &.span-1 {
    grid-row-end: span 1;
  }
  &.span-2 {
    grid-row-end: span 2;
  }
  &.span-3 {
    grid-row-end: span 3;
  }
  &.span-4 {
    grid-row-end: span 4;
  }
  &.span-5 {
    grid-row-end: span 5;
  }
  &.span-6 {
    grid-row-end: span 6;
  }
  &.span-7 {
    grid-row-end: span 7;
  }
  &.span-8 {
    grid-row-end: span 8;
  }
  &.span-9 {
    grid-row-end: span 9;
  }
  &.span-10 {
    grid-row-end: span 10;
  }
  &.span-11 {
    grid-row-end: span 11;
  }
  &.span-12 {
    grid-row-end: span 12;
  }
`;
